import { useDrag } from 'react-dnd';

import classNames from 'classnames';

import type { SavedSearchItem } from '@iconik-io/iconik-api/src/schema_patched/saved_search';
import { useDndRef } from '@iconik-io/shared-lib/src/react/hooks/use_dnd_ref';

import { FavouriteButton } from '../../components/favourite_button/favourite_button';
import { Link } from '../../components/link/link';
import DraggableTypes from '../../constants/draggable_types';
import type { FCC } from '../../types/common';
import OpenContextMenuButton from '../../ui/table/open_context_menu_button/open_context_menu_button';

import styles from './saved_search.module.css';

type Props = {
  isSelected: boolean;
  isActive: boolean;
  isIndented?: boolean;
  item: SavedSearchItem;
  onDrop?: (targetId: string) => void;
};

const SavedSearch: FCC<Props> = (props) => {
  const { item, isSelected, isIndented, isActive } = props;

  const [, dragRef] = useDrag(() => ({
    type: DraggableTypes.SAVED_SEARCH,
    item: {
      id: props.item.id,
      object_type: props.item.object_type,
    },
  }));

  const dragSourceRef = useDndRef(dragRef);

  const nameElement = isActive ? (
    <div className={styles.name}>{item.name}</div>
  ) : (
    <span className={styles.name}>
      <Link to={`/savedsearch/${item.id}`}>{item.name}</Link>
    </span>
  );

  return (
    <div
      ref={dragSourceRef}
      className={classNames(styles.root, {
        [styles.selected]: isSelected,
        [styles.indented]: isIndented,
        [styles.active]: isActive,
      })}
      data-id={item.id}
      role="option"
      aria-label={item.name}
      aria-selected={isSelected}
      tabIndex={0}
    >
      {nameElement}
      <FavouriteButton
        className={styles.favourite_button}
        id={item.id}
        title={item.name}
        favoured={Boolean(item.favoured)}
        objectType="saved_searches"
      />
      <OpenContextMenuButton />
    </div>
  );
};

export default SavedSearch;
